var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeamonkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 93C72.1812 93 93 72.1812 93 46.5C93 20.8188 72.1812 0 46.5 0C20.8188 0 0 20.8188 0 46.5C0 72.1812 20.8188 93 46.5 93Z",
    fill: "url(#paint0_linear_1202_6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71875 85.25C33.2604 69.75 49.4062 50.6979 57.1562 28.0937C64.9062 -8.71877 95.9062 6.78123 75.5625 20.3437C95.9062 29.0625 83.3125 67.8125 36.8125 71.6875C30.3542 79.4375 20.9896 83.9583 8.71875 85.25Z",
    stroke: "#CCCCCC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 83.3125C32.2917 67.8125 48.4375 48.7604 56.1875 26.1562C63.9375 -6.78126 94.9375 4.84374 74.5938 18.4062C94.9375 27.125 82.3438 65.875 35.8438 69.75C29.3854 77.5 20.0208 82.0208 7.75 83.3125Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1202_6",
    x1: 7.75,
    y1: 94.9375,
    x2: 7.75,
    y2: -1.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3AF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2E9C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamonkey);
export default __webpack_public_path__ + "static/media/seamonkey.e023fd7ae0a59a694d1eec5b0c1b2fb2.svg";
export { ForwardRef as ReactComponent };